module.exports = __webpack_public_path__ + "img/TLF_2000.d196db22.svg";